import 'css-chunksrc/client/scenes/preferences/profile/profilePicture/styles.scss';export default {
  "profilePicture": "_profilePicture_2wmpv_1",
  "input": "_input_2wmpv_12",
  "overlay": "_overlay_2wmpv_16",
  "icon": "_icon_2wmpv_29",
  "loader": "_loader_2wmpv_39"
};